/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import useDebounce from './useDebounce'

export type UseDebounceInputPropsType = {
  initialValue?: string
  onChange: (value: string, item?: any) => void
  delay?: number
  callbackOnInputChange?: (value: string) => void
}

export type HandleChangeType = (value: string, item?: any) => void

export type UseDebounceInputReturnType = [string, HandleChangeType]

const useDebounceInput = ({
  initialValue = '',
  onChange,
  delay = 500,
  callbackOnInputChange,
}: UseDebounceInputPropsType): UseDebounceInputReturnType => {
  const [isTouch, setIsTouch] = useState(false)
  const [input, setInput] = useState('')
  const [payload, setPayload] = useState(null)
  const [inputWithTimestamp, setInputWithTimestamp] = useState<{
    value: string
    timestamp: number
  } | null>(null)

  const debounceSearch = useDebounce(inputWithTimestamp, delay)

  const handleChange: HandleChangeType = (val: string, item?: any) => {
    if (!isTouch) {
      setIsTouch(true)
    }
    if (item) {
      setPayload(item)
    }
    setInput(val)
    setInputWithTimestamp({ value: val, timestamp: Date.now() })

    if (callbackOnInputChange) callbackOnInputChange(val)
  }

  useEffect(() => {
    if (isTouch && debounceSearch !== null) {
      onChange(debounceSearch.value, payload)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceSearch])

  useEffect(() => {
    if (initialValue) {
      setInput(initialValue)
    }
  }, [initialValue])

  return [input, handleChange]
}

export default useDebounceInput
export { useDebounceInput }
